import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Container, List, Item } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Avatar } from '../Avatar/components/Avatar.js';
import { AvatarLetter } from '../Avatar/components/AvatarLetter.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function AvatarList(props) {
  var avatars = props.avatars,
    _props$limit = props.limit,
    limit = _props$limit === void 0 ? 3 : _props$limit,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    restProps = __rest(props, ["avatars", "limit", "className", "size"]);
  var avatarsToDisplay = avatars === null || avatars === void 0 ? void 0 : avatars.slice(0, limit);
  var extra = avatars === null || avatars === void 0 ? void 0 : avatars.slice(limit);
  if (!avatarsToDisplay) {
    return null;
  }
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsxs(List, {
      className: className,
      children: [avatarsToDisplay.map(function (_a) {
        var id = _a.id,
          component = _a.component,
          restAvatarProps = __rest(_a, ["id", "component"]);
        return /*#__PURE__*/jsx(Item, {
          $size: size,
          children: /*#__PURE__*/jsx(Avatar, _extends({}, restProps, restAvatarProps, {
            size: size,
            children: component
          }))
        }, id);
      }), extra.length > 0 && /*#__PURE__*/jsx(Item, {
        $size: size,
        children: /*#__PURE__*/jsx(Avatar, _extends({}, restProps, {
          size: size,
          children: /*#__PURE__*/jsx(AvatarLetter, {
            children: "+" + extra.length
          })
        }))
      })]
    })
  });
}

export { AvatarList };
